/**
 * Settings page — server URL, API key, Gemini API key, asset tag prefix.
 */

import { router } from '../router.js';
import { getAllSettings, setSetting, isConfigured } from '../settings.js';
import { showToast } from '../toast.js';

export function renderSettings() {
  const app = document.getElementById('app');
  const s = getAllSettings();

  app.innerHTML = `
    <div class="page">
      <div class="page-header">
        <button class="back-btn" id="back-btn" aria-label="Back">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <h1>Settings</h1>
      </div>

      <div class="settings-section">
        <h2>Snipe-IT Connection</h2>
        <div class="card">
          <div class="form-group">
            <label for="set-server">Server URL</label>
            <input type="url" id="set-server" class="form-control" placeholder="https://your-snipeit.example.com" value="${escapeAttr(s.serverUrl)}" autocomplete="url" />
          </div>
          <div class="form-group">
            <label for="set-api-key">API Key</label>
            <input type="password" id="set-api-key" class="form-control" placeholder="Bearer token from Snipe-IT" value="${escapeAttr(s.apiKey)}" autocomplete="off" />
          </div>
          <button class="btn btn-secondary btn-sm" id="test-connection">Test Connection</button>
          <span id="test-status" role="status" aria-live="polite" style="margin-left:8px; font-size:0.85rem;"></span>
        </div>
      </div>

      <div class="settings-section">
        <h2>AI Extraction</h2>
        <div class="card">
          ${import.meta.env.VITE_PROXY_URL
            ? `<p style="font-size:0.9rem; color:var(--color-text-muted);">
                AI extraction is managed by your administrator.
               </p>`
            : `<div class="form-group">
                <label for="set-gemini">Gemini API Key</label>
                <input type="password" id="set-gemini" class="form-control" placeholder="Google AI Studio API key" value="${escapeAttr(s.geminiApiKey)}" autocomplete="off" />
               </div>
               <p style="font-size:0.8rem; color:var(--color-text-muted);">
                 Used for extracting device info from label photos. Get a key from
                 <a href="https://aistudio.google.com/apikey" target="_blank" rel="noopener" style="color:var(--color-primary);">Google AI Studio</a>.
               </p>`
          }
        </div>
      </div>

      <div class="settings-section">
        <h2>Asset Tags</h2>
        <div class="card">
          <div class="form-group">
            <label for="set-prefix">Asset Tag Prefix</label>
            <input type="text" id="set-prefix" class="form-control" placeholder="e.g. ASSET-" value="${escapeAttr(s.assetTagPrefix)}" />
          </div>
          <p style="font-size:0.8rem; color:var(--color-text-muted);">
            When auto-generating asset tags, this prefix is prepended.
          </p>
        </div>
      </div>

      <button class="btn btn-primary btn-block" id="save-settings" style="margin-top:8px;">
        Save Settings
      </button>

      <div style="margin-top:32px; text-align:center;">
        <p style="font-size:0.8rem; color:var(--color-text-muted);">SnipeySnipe v1.0.0</p>
      </div>
    </div>
  `;

  // ── Back ──
  document.getElementById('back-btn').addEventListener('click', () => {
    router.navigate('/');
  });

  // ── Test connection ──
  document.getElementById('test-connection').addEventListener('click', async () => {
    const url = document.getElementById('set-server').value.trim().replace(/\/+$/, '');
    const key = document.getElementById('set-api-key').value.trim();
    const status = document.getElementById('test-status');

    if (!url || !key) {
      status.textContent = 'Enter URL and API key first';
      status.style.color = 'var(--color-danger)';
      return;
    }

    status.innerHTML = '<span class="spinner"></span>';

    try {
      const res = await fetch(`${url}/api/v1/statuslabels?limit=1`, {
        headers: {
          Authorization: `Bearer ${key}`,
          Accept: 'application/json',
        },
      });
      if (res.ok) {
        status.textContent = '\u2713 Connected!';
        status.style.color = 'var(--color-success)';
      } else {
        status.textContent = `\u2717 Error: ${res.status}`;
        status.style.color = 'var(--color-danger)';
      }
    } catch (err) {
      status.textContent = '\u2717 Connection failed';
      status.style.color = 'var(--color-danger)';
    }
  });

  // ── Save ──
  document.getElementById('save-settings').addEventListener('click', () => {
    setSetting('serverUrl', document.getElementById('set-server').value);
    setSetting('apiKey', document.getElementById('set-api-key').value);
    if (!import.meta.env.VITE_PROXY_URL) {
      setSetting('geminiApiKey', document.getElementById('set-gemini').value);
    }
    setSetting('assetTagPrefix', document.getElementById('set-prefix').value);
    showToast('Settings saved');
  });
}

function escapeAttr(str) {
  return str.replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
